import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from '../types';

export const useLanguages = () => {
  const { i18n } = useTranslation();

  const [languages, setLanguages] = useState<Languages>({
    en: {
      name: 'English',
      nativeName: 'English',
      isReferenceLanguage: true,
      translated: {
        latest: 1,
      },
    },
  });

  useEffect(() => {
    i18n.services.backendConnector.backend.getLanguages(
      (err: unknown, res: Languages) => {
        if (err) {
          console.error('An error occurred while fetching languages: ', err);
          return;
        }
        setLanguages(res);
      }
    );
  }, [i18n]);

  return languages;
};
